import { Stack, Typography } from "@mui/material";
import useLocales from "src/hooks/useLocales";

export default function DialogTitle() {
	const { translate } = useLocales();
	return (
		<Stack sx={{ p: 3, pb: 0 }} gap={1}>
			<Typography variant='subtitle1' fontSize={21}>
				{translate("Eliminar aplicación")}
			</Typography>
			<Typography variant='body2' color='text.secondary'>
				{translate("Estás a punto de borrar esta aplicación. Esta accion será permanente.")}
			</Typography>
		</Stack>
	);
}
